import React from 'react';
import { connect } from 'react-redux';
import { branch, renderComponent, compose } from 'recompose';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { TopLineMenu, HorizontalMargin, TopLine, TopMobileLine, HoverableLink } from './style';
import { Icon } from '../Icons/Icons';
import Search from '../../Containers/Search';
import { Row } from '../../Layouts';
import { Text } from '../../UI/Text';
import { Button } from '../../UI/Button';
import { DropDownHamburger, DropDownMenu } from '../Dropdowns';

import { screenTypes } from '../../../Constants/screenTypes';
import screenWidthProvider from '../../Containers/HOCS/ScreenWidthProvider';
import { UserActionCreators } from '../../../Store/ActionCreators/UserActionCreators';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { generateSlugLink } from '../../../Utils';
import { externalLinks } from '../../../Constants/paths';

const isUserAuthenticated = () => {
    const isAccessToken = handleLoginService.isAuthenticated();
    return !isAccessToken;
};

const TonaLink = ({ path }) => (
    <HoverableLink to={{ pathname: path }} target="_blank">
        <Icon.Box size={'35x20'}>
            <Icon.Logo />
        </Icon.Box>
    </HoverableLink>
);

const NotAuthorizedUserMenu = () => {
    const tonafitLink = externalLinks.TONAFIT_LINK;
    return (
        <TopLineMenu>
            <TopLine>
                <TonaLink path={tonafitLink} />
                <HoverableLink to={'/sign-up'}>
                    <Button padding={'8px 20px'}>
                        <Text small>Join us</Text>
                    </Button>
                </HoverableLink>
            </TopLine>
        </TopLineMenu>
    );
};

const conditionalMenuDisplay = url => {
    const paths = ['selected', 'live', 'repeat', 'programme'];

    for (let i = 0; i < paths.length; i++) {
        if (url.includes(paths[i])) return false;
    }
    // if (url.includes()) return false;
    return true;
};

let TopMenu = ({ currentUser, signOutUser, screenWidth, location }) => {
    const currentUserLink = `/${generateSlugLink({
        name: currentUser.fullName,
        id: currentUser.id,
    })}`;

    return (
        conditionalMenuDisplay(location.pathname) && (
            <TopLineMenu>
                {screenWidth !== screenTypes.MOBILE ? (
                    <TopLine>
                        <TonaLink path={currentUserLink} />
                        <Row>
                            <HorizontalMargin>
                                <HoverableLink to={currentUserLink}>Profile</HoverableLink>
                            </HorizontalMargin>
                            <HorizontalMargin>
                                <HoverableLink to={`/planned`}>Plans</HoverableLink>
                            </HorizontalMargin>
                            <HorizontalMargin>
                                <HoverableLink to={`/planner`}>Plan Workout</HoverableLink>
                            </HorizontalMargin>
                            <HorizontalMargin>
                                <Search />
                            </HorizontalMargin>
                            <HorizontalMargin>
                                <DropDownMenu
                                    type={currentUser.type}
                                    name={currentUser.name}
                                    onLogout={() => signOutUser(() => (window.location.href = '/'))}
                                    profilePhoto={currentUser.smallImage}
                                />
                            </HorizontalMargin>
                        </Row>
                    </TopLine>
                ) : (
                    <TopMobileLine>
                        <TonaLink path={currentUserLink} />
                        <Row>
                            <HorizontalMargin>
                                <Search />
                            </HorizontalMargin>
                            <DropDownHamburger onLogout={() => signOutUser(() => (window.location.href = '/'))} />
                        </Row>
                    </TopMobileLine>
                )}
            </TopLineMenu>
        )
    );
};

TopMenu = branch(isUserAuthenticated, renderComponent(NotAuthorizedUserMenu))(TopMenu);
TopMenu.defaultProps = {
    singOutUser: () => {},
    currentUser: {},
};

TopMenu.propTypes = {
    signOutUser: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = ({ user }) => ({
    currentUser: user.currentUser,
});

const mapDispatchToProps = dispatch => ({
    signOutUser: completionCallback =>
        dispatch(UserActionCreators.signOutRequest({ device_id: 'somedeviceId' }, completionCallback)),
});

export default compose(
    screenWidthProvider,
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(TopMenu);



// WEBPACK FOOTER //
// ./src/UI/Components/TopMenu/index.js